import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * بيرجّع الصفحة لأعلاها عند فتح صفحة جديدة (مثلاً تفاصيل منتج بعد التمرير في القائمة).
 * زر الرجوع في المتصفح (POP) بيسيب المتصفح يرجّع مكان التمرير القديم.
 * بيتفاعل مع تغيّر المسار بس — فلاتر المنتجات (query string) ما بتحرّك الصفحة.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
